import { styled, StyleProps } from "../../styles"
import { getButtonCss, BaseButtonProps } from "../../Button/ButtonStyles"

const IconButton = styled.button<BaseButtonProps>((props: StyleProps) => ({
  ...getButtonCss(props),
  width: 20,
  height: 20,
  display: `flex`,
  justifyContent: `center`,
  alignItems: `center`,
  borderRadius: 10,
  backgroundColor: props.theme.palette.grey.light,
  marginLeft: props.theme.spacing(5),
  cursor: `pointer`,
}))

export default IconButton
